import React from 'react';

import Button from '@atlaskit/button/default/button';

export default function ButtonDefaultExample(): React.JSX.Element {
	return <Button>Default button</Button>;
}
